import React from 'react';
import { Link } from 'react-router-dom';

const FinalCTA = ({ onOpenConsultation }) => {
  return (
    <section className="py-5 position-relative overflow-hidden" style={{ background: '#f8fafc' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

        .cta-section {
          font-family: 'Inter', sans-serif;
        }

        .cta-box {
          background: linear-gradient(135deg, #040f1f 0%, #061830 60%, #CFA047 100%);
          border-radius: 32px;
          padding: 80px 48px;
          color: white;
          text-align: center;
          position: relative;
          overflow: hidden;
          box-shadow: 0 24px 48px rgba(6, 24, 48, 0.18);
        }

        .cta-box::before {
          content: '';
          position: absolute;
          top: -120px;
          right: -120px;
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);
          pointer-events: none;
        }

        .cta-box::after {
          content: '';
          position: absolute;
          bottom: -150px;
          left: -150px;
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(255,255,255,0.06) 0%, transparent 70%);
          pointer-events: none;
        }

        .cta-title {
          font-size: 44px;
          font-weight: 800;
          letter-spacing: -1.5px;
          margin-bottom: 20px;
          line-height: 1.2;
        }

        .cta-sub {
          font-size: 17px;
          color: rgba(255, 255, 255, 0.8);
          max-width: 650px;
          margin: 0 auto 40px;
          line-height: 1.7;
        }

        .cta-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 18px 44px;
          background: #ffffff;
          color: #061830;
          border: none;
          border-radius: 50px;
          font-size: 16px;
          font-weight: 800;
          cursor: pointer;
          transition: transform 0.2s, box-shadow 0.2s, background-color 0.2s;
          box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
        }

        .cta-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 14px 32px rgba(0, 0, 0, 0.18);
          background-color: #f8fafc;
        }

        @media (max-width: 767px) {
          .cta-box {
            padding: 50px 24px;
            border-radius: 24px;
          }
          .cta-title {
            font-size: 32px;
          }
          .cta-sub {
            font-size: 15px;
            margin-bottom: 30px;
          }
          .cta-btn {
            padding: 14px 32px;
            font-size: 14.5px;
          }
        }
      `}</style>

      <div className="container cta-section">
        <div className="cta-box">
          <h2 className="cta-title">Ready to Start Your Business Journey?</h2>
          <p className="cta-sub">
            Get expert guidance for registrations, licenses, certifications, and compliance services anywhere in India.
          </p>
          <button 
            type="button"
            className="cta-btn"
            onClick={() => onOpenConsultation()}
          >
            Request a Free Consultation <i className="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
